import React from "react"
import { Box, Divider, SimpleGrid, Spacer, Text } from "@chakra-ui/react"
import { useSizeGuideMetadata } from "./sizeGuideMetadata"
import { IngmarsonCard } from "../card"

const SizeGuide = ({ size, extraSizeInfo, isDesign = false }) => {
  // console.l9g
  const sizeGuide = useSizeGuideMetadata({ size })
  console.log("SIZE GUIDE XXXX", size)
  return (
    <>
      {(sizeGuide) && 
        <IngmarsonCard
          id="sizeguide"
          variant="Grey"
          backgroundColor={'brandWhite.50'}
          width="100%"
          marginTop={3}
          padding={10}
        >
          <IngmarsonCard variant="sizes" textAlign="center">
            {sizeGuide &&
              <IngmarsonCard textStyle="h3u">
                {isDesign ? "GUIDE" : "SIZE GUIDE"}
              </IngmarsonCard>
            }
            {sizeGuide &&
              <Box mb={3} pt={5}>
                {sizeGuide.description}
              </Box>
            }            
            {sizeGuide &&
              <IngmarsonCard variant="sizes" pt={5}>
                <SimpleGrid columns={[2, 2, 4, 4]} spacing={10} id="sizeGroups">
                  {sizeGuide.sizeGroups.map((g, index) => (
                    <Box key={g.sizeGroup}>
                      <Box textStyle="h4u" size="xs">
                        {g.sizeGroup}
                      </Box>
                      {g.size.map((s, index) => (
                        <Box key={`size${index}`} pt={1}>
                          <Box textStyle="h6" >{s.sizeType}</Box>
                          <Box textStyle="t6" mb={3} >{s.size}</Box>
                        </Box>
                      ))}
                    </Box>
                  ))}
                </SimpleGrid>
              </IngmarsonCard>
            }
            {!isDesign && extraSizeInfo &&
              <Text mb={3} pt={0} whiteSpace={'pre-line'}>
                {extraSizeInfo}
              </Text>
            }
          </IngmarsonCard>
        </IngmarsonCard>
      }
      {(isDesign && extraSizeInfo) && 
        <IngmarsonCard
          id="sizeguide"
          variant="Grey"
          backgroundColor={'brandWhite.50'}
          width="100%"
          marginTop={5}
          marginBottom={5}
          padding={10}
        >
          <IngmarsonCard variant="sizes" textAlign="center">
              <Text mb={3} pt={0} whiteSpace={'pre-line'}>
                {extraSizeInfo}
              </Text>
          </IngmarsonCard>
        </IngmarsonCard>
      }
    </>
  )
}

export default SizeGuide

